import { render, staticRenderFns } from "./PushTaskBackDialog.vue?vue&type=template&id=5372f309&scoped=true"
import script from "./PushTaskBackDialog.vue?vue&type=script&lang=js"
export * from "./PushTaskBackDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5372f309",
  null
  
)

export default component.exports